/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */

// navigation
aucor_navigation(document.getElementById('primary-navigation'), {
  desktop_min_width: 1220, // min width in pixels
  menu_toggle: '#menu-toggle' // selector for toggle
});

// search toggle
aucor_search_toggle(document.getElementById('masthead').querySelector('.site-header__search-form'), {
  search_toggle: document.getElementById('masthead').querySelector('.site-header__search-toggle')
});

/**
 * Video
 */

// responsive videos
fitvids();

// hero video
var hero_video = document.getElementById('hero-video');

if (hero_video) {
  hero_video.addEventListener('canplaythrough', function() {
    this.play();
  });
}

/**
 * Scroll position
 */

var scroll_btn = document.getElementById('back-to-top');

if (scroll_btn) {
  window.addEventListener('scroll', function(){
    var scroll_pos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;

    if (scroll_pos > 500) {
      if (!scroll_btn.classList.contains('to-top--active')) {
        scroll_btn.classList.add('to-top--active');
      }
    } else {
      if (scroll_btn.classList.contains('to-top--active')) {
        scroll_btn.classList.remove('to-top--active');
      }
    }
  });
}
/**
 * Sticky header
 */

var header_opts = {
  offset: 400,
  classes: {
    clone: 'site-header--clone',
    stick: 'site-header--stick',
    unstick: 'site-header---unstick'
  },
  throttle: 150,
  onInit: function() {
    var cloned = document.querySelector('.site-header--clone');
    var search_toggle = cloned.querySelector('.site-header__search-toggle');
    var search = cloned.querySelector('.site-header__search-form');

    cloned.setAttribute('id', 'masthead-cloned');

    // attach event listener to cloned search toggle
    aucor_search_toggle(search, {
      search_toggle: search_toggle
    });
  },
  onStick: function() {
    var origin = document.getElementById('masthead');

    var search_toggle = origin.querySelector('.site-header__search-toggle');
    var search = origin.querySelector('.site-header__search-form');

    // remove active state from original search on stick
    if (search_toggle.classList.contains('search-toggle--active')) {
      // remove .active class from search toggle
      search_toggle.classList.remove('search-toggle--active');
      search_toggle.setAttribute('aria-expanded', 'false');

      // remove .active class from body and search container
      search.classList.remove('active');
      document.body.classList.remove('search-form--active');
    }
  },
  onUnstick: function() {
    var cloned = document.getElementById('masthead-cloned');

    var search_toggle = cloned.querySelector('.site-header__search-toggle');
    var search = cloned.querySelector('.site-header__search-form');

    // remove active state from cloned search on unstick
    if (search_toggle.classList.contains('search-toggle--active')) {
      // remove .active class from search toggle
      search_toggle.classList.remove('search-toggle--active');
      search_toggle.setAttribute('aria-expanded', 'false');

      // remove .active class from body and search container
      search.classList.remove('active');
      document.body.classList.remove('search-form--active');
    }
  }
};

var header = new Headhesive('.site-header', header_opts);

/**
 * Smooth scroll
 */

var supports = function () {
  return (
    'querySelector' in document &&
    'addEventListener' in window &&
    'requestAnimationFrame' in window &&
    'closest' in window.Element.prototype
  );
};

if (supports()) {
  var scroll = new SmoothScroll('a[href*="#"]', {
    offset: 160,
    updateURL: false
  });
}

/**
 * Accordion
 */

// check if any accordion elements exists
if (document.getElementsByClassName('accordion').length > 0) {

  var links = document.querySelectorAll('a[href^="#"]');

  // loop through all #links
  for (var i = 0, len = links.length; i < len; i++) {
    links[i].addEventListener('click', function(e) {

      // link
      accordion_toggle = this;

      // get link hash
      accordion_id = this.hash.substr(1);

      // find elements with matching id
      accordion = document.getElementById(accordion_id);

      // toggle if matching element found
      if (accordion_id && accordion && accordion.classList.contains('accordion')) {
        e.preventDefault();

        // set id for toggle link to smooth scroll back on close
        accordion_toggle.setAttribute('id', accordion_id + '-toggle');

        // store original link label to local storage if button is not active, i.e. do not save 'Close'
        if (!accordion.classList.contains('accordion--active')) {
          localStorage.setItem('link_text_' + accordion_id, accordion_toggle.innerHTML);
        }

        // closing link label from translation strings
        var close_text = accordion.getAttribute('data-accordion-close');

        // add close link and
        if (!accordion.querySelector('.accordion__close')) {
          accordion.innerHTML += '<div class="accordion__close"><a href="#' + accordion_id + '-toggle' + '" class="button" data-id="' + accordion_id + '">' + close_text + '</a></div>';

          accordion.querySelector('.accordion__close a').addEventListener('click', function(e) {
            e.preventDefault();

            /*
              We're fetching the parent element the hard way, because if we use just accordion,
              accordion_toggle etc. we get the element that was last opened, which isn't necessarily
              the correct parent to the close button pressed (multiple accordions open for example)
            */
            parent_accordion = document.getElementById(this.dataset.id);
            parent_accordion_toggle = document.getElementById(this.dataset.id + '-toggle');
            parent_close_text = parent_accordion.getAttribute('data-accordion-close');

            toggle_accordion(parent_accordion, parent_accordion_toggle, parent_close_text);
          });
        }

        // do some toggling
        toggle_accordion(accordion, accordion_toggle, close_text);
      }
    });
  }

}

var toggle_accordion = function(accordion, accordion_toggle, close_text){
  if (accordion.classList.contains('accordion--active')) {
    accordion.classList.remove('accordion--active');
    accordion_toggle.classList.remove('button--active');

    // get label saved on button click
    accordion_toggle.innerHTML = localStorage.getItem('link_text_' + String(accordion.id));
  } else {
    accordion.classList.add('accordion--active');
    accordion_toggle.classList.add('button--active');

    // swap to close label
    accordion_toggle.innerHTML = close_text;
  }
};

/**
 * Carousel
 */

if (document.getElementsByClassName('block--slider__slides').length > 0) {
  var carousels = document.querySelectorAll('.block--slider__slides');
  var prev_buttons = document.querySelectorAll('.block--slider__slides__previous');
  var next_buttons = document.querySelectorAll('.block--slider__slides__next');
  var slide_nr = document.querySelectorAll('.block--slider__total__current');
  var slide_total = document.querySelectorAll('.block--slider__total__number');
  var siemas = [];

  for(var i = 0; i < carousels.length; i++) {
    siemas[i] = new Siema({
      selector: carousels[i],
      draggable: false,
      // these are usefull when only 1 slide is present, but problematic with multiple
      // onInit: carouselOnInit,
      // onChange: carouselOnChange,
    });

    slide_nr[i].innerHTML = siemas[i].currentSlide + 1;
    slide_total[i].innerHTML = siemas[i].innerElements.length;

    prev_buttons[i].addEventListener('click', prevListener(i));
    next_buttons[i].addEventListener('click', nextListener(i));

    function prevListener(i) {
      // the closure is critical in both listener functions
      return function() {
        siemas[i].prev();
        var number = slide_nr[i].innerHTML;
        if (number > 1) {
          number--;
          slide_nr[i].innerHTML = number;
        }
      }
    }

    function nextListener(i) {
      return function() {
        siemas[i].next();
        var number = slide_nr[i].innerHTML;
        if (number < (siemas[i].innerElements.length)) {
          number++;
          slide_nr[i].innerHTML = number;
        }
      }
    }
  }
}

// refire object-fit polyfill
window.addEventListener('load', function() {
  objectFitPolyfill();
});

// add jquery as dependency in functions.php and uncomment the following if you need jquery
//
// (function($) {
//   $(document).ready(function(){
//
//   });
// })(jQuery);
